import slideImage01 from "../../../assets/images/home/learn-more/slide-01.png";
import slideImage02 from "../../../assets/images/home/learn-more/slide-02.png";
import slideImage03 from "../../../assets/images/home/learn-more/slide-03.png";
import slideImage04 from "../../../assets/images/home/learn-more/slide-04.png";

export const homeLearnMoreSliderData = [
  {
    id: 1,
    title: "WhatIsClubPass",
    text: "ClubPassIsACreditBasedMembership",
    imagePath: slideImage01,
  },
  {
    id: 2,
    title: "HowDoCreditsWork",
    text: "OurPlansIncludeCreditsToUseForBooking",
    imagePath: slideImage02,
  },
  {
    id: 3,
    title: "WhatsTheBenefitOfBooking",
    text: "ClubPassGivesYouExclusiveMemberRates",
    imagePath: slideImage03,
  },
  {
    id: 4,
    title: "CanITryWithoutCommitment",
    text: "YesTryClubPass7DaysFreeTrialToday",
    imagePath: slideImage04,
  },
];
